import React from 'react';
import Tabs, { Tab } from "@nokia-csf-uxr/ccfk/Tabs";
import { useLocation, useNavigate } from 'react-router-dom';

const ARIA_LABEL_TEXT_1 = 'To select Tab ';
const ARIA_LABEL_TEXT_2 = ' press spacebar';

const MarketplaceTabs: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const tabData = [
    { tab: { children: 'Marketplace Store', label: 'Marketplace Store' } },
    { tab: { children: 'Quotes', label: 'Quotes' } },
  ];

  // Prefer navigation state (set when navigating) then fall back to query param for compatibility
  const stateTab = (location.state && (location.state as any).tab) || '';
  const queryTab = new URLSearchParams(location.search).get('tab') || '';
  const activeTab = (stateTab || queryTab || '').toString();
  const selected = activeTab.toLowerCase() === 'quotations' ? 1 : 0;

  const handleSelect = (i: number) => {
    if (i === 1) navigate('/marketplace', { state: { tab: 'quotations' } });
    else navigate('/marketplace', { state: { tab: 'marketplace' } });
  };

  return (
    <div className="mp-tabs-override" style={{ display: 'flex', justifyContent: 'space-between' }}>
      <style>{`.mp-tabs-override [class*="TabWrapper"] { margin: 0 !important; }`}</style>
      <Tabs alignment="left" fullWidth={false} variant="default">
        {tabData.map(({ tab }, i) => {
          const ariaMainText = tab && tab.label;
          const { children: tabChildren, ...tabProps } = tab || {};
          return (
            <Tab
              id={`mp-tab-${i}`}
              aria-label={selected === i ? `${ariaMainText}` : `${ARIA_LABEL_TEXT_1} ${ariaMainText} ${ARIA_LABEL_TEXT_2} `}
              aria-controls={`tab-content-${i}`}
              aria-posinset={(tab && tab.label) ? i + 1 : undefined}
              aria-setsize={(tab && tab.label) ? tabData.length : undefined}
              role="option"
              key={`mp-tab-${i}`}
              selected={selected === i}
              onSelect={() => handleSelect(i)}
              {...tabProps}
            >
              {tabChildren}
            </Tab>
          );
        })}
      </Tabs>
    </div>
  );
};

export default MarketplaceTabs;
